export default async function onUrlChange(store, page, category, action, id) {
  const endpoint = store.getEndpoint(page);
  if (!page) {
    // Reset the state to its base UI state
    store.setState({ ...page, ...store.state, ...store.uiState });
    return;
  } else {
    // Page depended endpoints
    if (store.state.endpoint !== endpoint) {
      store.setState({ endpoint: endpoint });
    }
    if (page === "reports" && category === "reports") {
      await store.getAllReports();
    }
  }

  if (page === "account") {
    store.getMfa();
  }

  if (category) {
    store.setState({ category });
  }

  if (!id && store.state.item) {
    store.setState({ item: undefined, HTMLReport: undefined });
  }

  if (id) {    
    // Report module
    if (page === "reports") {
      if (id !== store.state.currentId) {
        // clear current item
        await store.setState({ report: undefined });
      }
      store.getReportItem(id);
      await store.setState({ currentId: id });
    }
    
  }

  store.setState({ page, action });
}
